function getFocusableElements(container) {
  if (!container) return [];

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
    )
  );
}

const trapFocusHandlers = {};
const warningTime = 3000;

function trapFocus(container, elementToFocus = container) {
  if (!container) return;

  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = (event) => {
    if (event.key !== "Tab" || !first || !last) return;

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus && typeof elementToFocus.focus === "function") {
    elementToFocus.focus();
  }
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow?.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  });

  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow?.postMessage('{"method":"pause"}', "*");
  });

  document.querySelectorAll("video").forEach((video) => video.pause());

  document.querySelectorAll("product-model").forEach((model) => {
    model.modelViewerUI?.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && typeof elementToFocus.focus === "function") {
    elementToFocus.focus();
  }
}

function debounce(fn, wait) {
  let timer;

  return function (...args) {
    const context = this;

    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(context, args), wait);
  };
}

const serializeForm = (form) => {
  const object = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    object[key] = formData.get(key);
  }

  return JSON.stringify(object);
};

function throttle(fn, delay) {
  let lastCall = 0;

  return function (...args) {
    const now = Date.now();

    if (now - lastCall < delay) return;

    lastCall = now;
    return fn.apply(this, args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    }
  };
}

function extractContent(string) {
  const div = document.createElement("div");
  div.innerHTML = string;

  return div.textContent || div.innerText || "";
}

/* Shopify common helpers */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  if (!selector) return;

  for (let i = 0; i < selector.options.length; i++) {
    const option = selector.options[i];

    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  if (!target) return;

  target.addEventListener(eventName, callback, false);
};

Shopify.postLink = function (path, options) {
  options = options || {};

  const form = document.createElement("form");
  const parameters = options.parameters || {};

  form.setAttribute("method", options.method || "post");
  form.setAttribute("action", path);

  Object.keys(parameters).forEach((key) => {
    const field = document.createElement("input");

    field.type = "hidden";
    field.name = key;
    field.value = parameters[key];

    form.appendChild(field);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
};

Shopify.CountryProvinceSelector = function (
  countryId,
  provinceId,
  options
) {
  options = options || {};

  this.countryEl = document.getElementById(countryId);
  this.provinceEl = document.getElementById(provinceId);
  this.provinceContainer = document.getElementById(
    options.hideElement || provinceId
  );

  if (!this.countryEl || !this.provinceEl) return;

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    Shopify.setSelectorByValue(
      this.countryEl,
      this.countryEl.getAttribute("data-default")
    );

    this.countryHandler();
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute("data-default");

    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function () {
    const option = this.countryEl.options[this.countryEl.selectedIndex];
    if (!option) return;

    let provinces = [];

    try {
      provinces = JSON.parse(option.getAttribute("data-provinces") || "[]");
    } catch {
      provinces = [];
    }

    this.clearOptions(this.provinceEl);

    if (!provinces || provinces.length === 0) {
      if (this.provinceContainer) {
        this.provinceContainer.style.display = "none";
      }

      return;
    }

    provinces.forEach((province) => {
      const provinceOption = document.createElement("option");

      provinceOption.value = province[0];
      provinceOption.textContent = province[1];

      this.provinceEl.appendChild(provinceOption);
    });

    if (this.provinceContainer) {
      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    selector.replaceChildren();
  },

  setOptions: function (selector, values) {
    values.forEach((value) => {
      const option = document.createElement("option");

      option.value = value;
      option.textContent = value;

      selector.appendChild(option);
    });
  }
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString =
    format ||
    this.money_format ||
    window.money_format ||
    "{{amount}}";

  const placeholder = formatString.match(placeholderRegex);

  if (!placeholder) return formatString;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) return "0";

    const parts = (Number(number) / 100).toFixed(precision).split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const decimals = parts[1] ? decimal + parts[1] : "";

    return dollars + decimals;
  }

  let value;

  switch (placeholder[1]) {
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;

    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;

    default:
      value = formatWithDelimiters(cents);
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.getCart = function (callback) {
  const cartUrl = window.routes?.cart || "/cart";

  $.getJSON(`${cartUrl}.js`, function (cart) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

Shopify.onCartUpdate = function (cart) {
  alert("There are now " + cart.item_count + " items in the cart.");
};

Shopify.changeItem = function (
  variantId,
  quantity,
  index,
  callback
) {
  return getCartUpdate(index, quantity, callback);
};

Shopify.removeItem = function (variantId, index, callback) {
  return getCartUpdate(index, 0, callback);
};

function getCartUpdate(line, quantity, callback) {
  const body = JSON.stringify({
    line,
    quantity,
    sections_url: window.location.pathname
  });

  return fetch(window.routes?.cart_change_url || "/cart/change", {
    ...fetchConfig(),
    body
  })
    .then((response) => response.json())
    .then((state) => {
      if (state.errors) {
        const message =
          typeof state.errors === "string"
            ? state.errors
            : JSON.stringify(state.errors);

        showWarning("Error : " + message, warningTime);
        return;
      }

      if (typeof callback === "function") {
        callback(state);
      } else {
        Shopify.onCartUpdate(state);
      }
    })
    .catch((error) => {
      console.error(error);

      showWarning(
        window.cartStrings?.error || "Unable to update the cart.",
        warningTime
      );
    });
}

Shopify.addItem = function (
  variantId,
  quantity,
  $target,
  callback,
  input = null
) {
  const data = new URLSearchParams();

  data.set("quantity", quantity || 1);
  data.set("id", variantId);

  if ($target && typeof $target.closest === "function") {
    const form = $target.closest("form");

    if (form && typeof form.find === "function") {
      form.find('[name^="properties"]').each((index, element) => {
        data.append(element.name, $(element).val());
      });
    }
  }

  return $.ajax({
    type: "POST",
    url: `${window.routes?.cart_add_url || "/cart/add"}.js`,
    data: data.toString(),
    dataType: "json",

    success: function (lineItem) {
      if (typeof callback === "function") {
        callback(lineItem);
      } else {
        Shopify.onItemAdded(lineItem);
      }
    },

    error: function (xhr, textStatus) {
      let message =
        window.cartStrings?.addProductOutQuantity2 ||
        window.cartStrings?.error ||
        "Unable to add this item.";

      if (input && input.length > 0) {
        const maximum = parseInt(
          input.attr("data-inventory-quantity"),
          10
        );

        if (Number.isFinite(maximum)) {
          message = getInputMessage(maximum);
          input.val(maximum);
        }
      }

      Shopify.onError(xhr, textStatus, message);

      if ($target && typeof $target.removeClass === "function") {
        $target.removeClass("is-loading");
      } else {
        $target?.classList?.remove("is-loading");
      }
    }
  });
};

Shopify.onItemAdded = function (lineItem) {
  alert(lineItem.title + " was added to your shopping cart.");
};

Shopify.onError = function (xhr, textStatus, message) {
  let data = xhr.responseJSON;

  if (!data || typeof data !== "object") {
    try {
      data = JSON.parse(xhr.responseText || "{}");
    } catch {
      data = {};
    }
  }

  let content =
    data.description ||
    data.message ||
    message ||
    window.cartStrings?.error ||
    "Something went wrong. Please try again.";

  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }

  showWarning(content, warningTime);
};

/* Drawers */

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    if (!this.mainDetailsToggle) return;

    this.addAccessibilityAttributes(this.querySelectorAll("summary"));

    if (navigator.platform === "iPhone") {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));

    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => {
      summary.addEventListener("click", this.onSummaryClick.bind(this));
    });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(elements) {
    elements.forEach((element) => {
      element.setAttribute("role", "button");

      element.setAttribute(
        "aria-expanded",
        String(element.parentElement.hasAttribute("open"))
      );

      if (element.nextElementSibling?.id) {
        element.setAttribute(
          "aria-controls",
          element.nextElementSibling.id
        );
      }
    });
  }

  onKeyUp(event) {
    if (event.key !== "Escape") return;

    const openDetails = event.target.closest("details[open]");
    if (!openDetails) return;

    if (openDetails === this.mainDetailsToggle) {
      this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      );
    } else {
      this.closeSubmenu(openDetails);
    }
  }

  onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.parentElement;
    const isOpen = details.hasAttribute("open");

    if (details === this.mainDetailsToggle) {
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(event, summary);
      } else {
        this.openMenuDrawer(summary);
      }

      return;
    }

    if (!isOpen) {
      trapFocus(
        summary.nextElementSibling,
        details.querySelector("button") || summary
      );

      setTimeout(() => details.classList.add("menu-opening"));
    }

    summary.setAttribute("aria-expanded", String(!isOpen));
  }

  openMenuDrawer(summary) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summary.setAttribute("aria-expanded", "true");

    trapFocus(this.mainDetailsToggle, summary);
    document.body.classList.add("overflow-hidden-mobile");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.classList.remove("menu-opening");

    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");

      details.querySelector("summary")?.setAttribute(
        "aria-expanded",
        "false"
      );
    });

    this.mainDetailsToggle.querySelector("summary")?.setAttribute(
      "aria-expanded",
      "false"
    );

    document.body.classList.remove("overflow-hidden-mobile");

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle?.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      ) {
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const details = event.currentTarget.closest("details");
    if (!details) return;

    if (details === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, details.querySelector("summary"));
    } else {
      this.closeSubmenu(details);
    }
  }

  closeSubmenu(details) {
    if (!details) return;

    details.classList.remove("menu-opening");
    details.querySelector("summary")?.setAttribute(
      "aria-expanded",
      "false"
    );

    removeTrapFocus();
    this.closeAnimation(details);
  }

  closeAnimation(details) {
    clearTimeout(details._smCloseTimer);

    details._smCloseTimer = setTimeout(() => {
      details.removeAttribute("open");

      const parentDetails = details.parentElement?.closest("details[open]");

      if (parentDetails) {
        trapFocus(parentDetails, details.querySelector("summary"));
      }
    }, 400);
  }
}

if (!customElements.get("menu-drawer")) {
  customElements.define("menu-drawer", MenuDrawer);
}

class HeaderDrawer extends MenuDrawer {
  openMenuDrawer(summary) {
    this.header =
      this.header ||
      document.getElementById("shopify-section-header") ||
      this.closest(".shopify-section");

    const wrapper = this.closest(".header-wrapper");
    const borderOffset = wrapper?.classList.contains(
      "header-wrapper--border-bottom"
    )
      ? 1
      : 0;

    if (this.header) {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${Math.round(
          this.header.getBoundingClientRect().bottom - borderOffset
        )}px`
      );
    }

    super.openMenuDrawer(summary);
  }
}

if (!customElements.get("header-drawer")) {
  customElements.define("header-drawer", HeaderDrawer);
}

/* Quantity controls */

class UpdateQuantity extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeCart = null;
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll(".btn-quantity").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }

  disconnectedCallback() {
    clearTimeout(this.changeCart);
  }

  onButtonClick(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const quantityInput =
      target.parentElement.querySelector(".quantity") || this.input;

    if (!quantityInput || !this.input) return;

    const value = Number(quantityInput.value) || 0;
    const stock = Number(quantityInput.dataset.inventoryQuantity);
    const addButton = target.closest(".product-form")?.querySelector(
      "[data-btn-addtocart]"
    );

    const quickShop = document.body.matches(".quickshop-popup-show");

    const policyArray = quickShop
      ? window[`quick_shop_policy_array_${this.input.dataset.product}`]
      : window[`cart_selling_array_${this.dataset.product}`];

    const currentId = quickShop
      ? this.closest(".productView-options")?.querySelector(
          '[name="id"]'
        )?.value
      : this.input.dataset.cartQuantityId;

    const variantPolicy = policyArray?.[currentId];

    const checkAvailable =
      addButton?.dataset.available === "false" ||
      addButton?.dataset.available === undefined;

    let newValue = value;

    if (target.matches(".plus")) {
      newValue = value + 1;
    } else if (target.matches(".minus")) {
      newValue = value - 1;
    }

    if (newValue < 0) newValue = 1;

    if (
      Number.isFinite(stock) &&
      newValue > stock &&
      checkAvailable &&
      variantPolicy === "deny"
    ) {
      showWarning(getInputMessage(stock), warningTime);
      newValue = stock;
    }

    quantityInput.value = newValue;

    clearTimeout(this.changeCart);

    this.changeCart = setTimeout(() => {
      this.input.dispatchEvent(this.changeEvent);
    }, 350);
  }

  quantityCheckedToBeContinue() {
    const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
    const input = this.querySelector('[name="quantity"]');

    return Boolean(
      input &&
      sellingArray &&
      sellingArray[input.dataset.cartQuantityId] === "continue"
    );
  }
}

class UpdateQuantityQuickShop extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    if (!this.input) return;

    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll(".btn-quantity").forEach((button) => {
      button.addEventListener(
        "click",
        this.onChangeQuantity.bind(this)
      );
    });

    this.input.addEventListener(
      "change",
      this.onChangeQuantity.bind(this)
    );
  }

  onChangeQuantity(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const input =
      target.parentElement.querySelector(".quantity") || this.input;

    const quickShop = this.closest("[data-quickshop]");
    const addButton = quickShop?.querySelector("[data-btn-addtocart]");

    if (!input || !quickShop || !addButton) return;

    const value = Number(input.value) || 1;
    const stock = Number(input.dataset.inventoryQuantity);

    let newValue = value;

    if (target.matches(".plus")) {
      newValue = value + 1;
    } else if (target.matches(".minus")) {
      newValue = value - 1;
    }

    if (newValue <= 0) newValue = 1;

    if (
      Number.isFinite(stock) &&
      newValue > stock &&
      !addButton.matches(".button--pre-untrack")
    ) {
      showWarning(getInputMessage(stock), warningTime);
      newValue = stock;
    }

    input.value = newValue;

    const realQuantityInput = quickShop.querySelector(
      'form input[name="quantity"]'
    );

    if (realQuantityInput) {
      realQuantityInput.value = newValue;
      realQuantityInput.setAttribute("value", newValue);
    }

    if (target.matches(".btn-quantity")) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

/* Drag scrolling */

class ProductScroller extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector("[data-drag-container]");
    this.dragParent = this.querySelector("[data-drag-parent]");

    this.initDragToScroll();
  }

  initDragToScroll() {
    if (!this.container) return;

    const overflowing =
      this.container.clientWidth < this.container.scrollWidth;

    this.dragToScroll(
      overflowing ? this.container : this.dragParent || this.container
    );
  }

  dragToScroll(slider) {
    if (!slider) return;

    let mouseDown = false;
    let start = 0;
    let scrollLeft = 0;
    let inactiveTimeout;

    const stopDragging = () => {
      mouseDown = false;
      clearTimeout(inactiveTimeout);

      inactiveTimeout = setTimeout(() => {
        slider.classList.remove("active");
      }, 150);
    };

    slider.addEventListener("mousedown", (event) => {
      if (event.button !== 0) return;

      mouseDown = true;
      start = event.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseup", stopDragging);
    slider.addEventListener("mouseleave", stopDragging);

    slider.addEventListener("mousemove", (event) => {
      if (!mouseDown) return;

      event.preventDefault();
      slider.classList.add("active");

      const x = event.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - start);
    });
  }
}

class ImageToFlip extends HTMLElement {
  constructor() {
    super();
    this.imageContainer = this;
  }

  connectedCallback() {
    this.initObserver();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  initObserver() {
    if (!("IntersectionObserver" in window)) {
      this.classList.add("show");
      return;
    }

    this.observer?.disconnect();

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].isIntersecting) {
          this.classList.add("show");
          observer.unobserve(this);
        }
      },
      { threshold: 0.4 }
    );

    this.observer.observe(this);
  }
}

/* Warning messages */

function showWarning(content, time = null) {
  clearTimeout(window.warningTimeout);

  const popup = document.getElementById("halo-warning-popup");
  const popupContent = popup?.querySelector(
    "[data-halo-warning-content]"
  );

  if (!popupContent) {
    console.warn(content);
    return;
  }

  popupContent.textContent = content;
  document.body.classList.add("has-warning");

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove("has-warning");
    }, time);
  }
}

function getInputMessage(maxValue) {
  const message =
    window.cartStrings?.addProductOutQuantity ||
    "The maximum available quantity is [maxQuantity].";

  return message.replace("[maxQuantity]", maxValue);
}

/* Fade-in component */

class FadeInComponent extends HTMLElement {
  connectedCallback() {
    this.initObserver();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  initObserver() {
    this.observer?.disconnect();

    if (!("IntersectionObserver" in window)) {
      this.classList.add("fade-in");
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].isIntersecting) {
          this.classList.add("fade-in");
          observer.unobserve(this);
        }
      },
      { threshold: 0.7 }
    );

    this.observer.observe(this);
  }
}

/*
 * Scroll-linked banners.
 * Cache matching elements and schedule at most one update per frame.
 */

let smScrollingElements = [];
let smScrollingFrame = null;

function smRefreshScrollingElements() {
  smScrollingElements = Array.from(
    document.querySelectorAll("[data-scrolling]")
  );

  smQueueScrolling();
}

function smQueueScrolling() {
  if (smScrollingFrame !== null || !smScrollingElements.length) {
    return;
  }

  smScrollingFrame = requestAnimationFrame(() => {
    smScrollingFrame = null;
    loadScrolling();
  });
}

function loadScrolling() {
  smScrollingElements.forEach((element) => {
    if (!element.isConnected) return;

    if (element.dataset.scrolling === "vertical") {
      scrollVertical(element);
    } else {
      scrollHorizontal(element);
    }
  });
}

function scrollVertical(element) {
  const item = element.closest(".special-banner__item") || element;
  const rect = item.getBoundingClientRect();

  const top = rect.top;
  const height = rect.height;

  if (!height) return;

  const viewportHeight = window.innerHeight;
  const coefficient = element.scrollHeight / height;
  const redundant =
    height >= viewportHeight ? 0 : (viewportHeight - height) / 2;

  if (top - redundant < 0 && top > -height) {
    scrollTop(element, (-top + redundant) * coefficient);
  } else if (top - redundant >= 0) {
    scrollTop(element, 0);
  } else {
    scrollTop(element, element.scrollHeight);
  }
}

function scrollTop(element, scope) {
  element.scrollTo({
    top: scope,
    behavior: "smooth"
  });
}

function scrollHorizontal(element) {
  const first = element.querySelector(".scrolling-text__list--1");
  const second = element.querySelector(".scrolling-text__list--2");

  if (!first || !second) return;

  const rect = element.getBoundingClientRect();
  const top = rect.top;
  const height = rect.height;
  const viewportHeight = window.innerHeight;

  const firstWidth = first.scrollWidth;
  const viewportWidth = window.innerWidth;

  const scrollWidth = Math.max(0, firstWidth - viewportWidth);
  const contentHeight = first.getBoundingClientRect().height * 2;

  const redundant =
    height >= viewportHeight ? 0 : (viewportHeight - height) / 2;

  const denominator = height / 2 + redundant - contentHeight;
  const coefficient = denominator ? scrollWidth / denominator : 0;

  let scope = (-top + redundant) * coefficient;
  let scope2 =
    (height / 2 - contentHeight + redundant) * coefficient - scope;

  if (top - redundant < 0 && top - contentHeight > -height / 2) {
    scope *= -1;
    scope2 *= -1;
  } else if (top - redundant >= 0) {
    scope = 0;
    scope2 = -scrollWidth;
  } else {
    scope = -scrollWidth;
    scope2 = 0;
  }

  if (firstWidth <= viewportWidth) {
    if (second.style.justifyContent !== "flex-end") {
      second.style.justifyContent = "flex-end";
    }
  } else {
    translateX(first, second, scope, scope2);
  }
}

function translateX(first, second, scope, scope2) {
  const firstTransform = `translateX(${scope}px)`;
  const secondTransform = `translateX(${scope2}px)`;

  if (first.style.transform !== firstTransform) {
    first.style.transform = firstTransform;
  }

  if (second.style.transform !== secondTransform) {
    second.style.transform = secondTransform;
  }
}

window.addEventListener("scroll", smQueueScrolling, {
  passive: true
});

window.addEventListener("resize", smQueueScrolling, {
  passive: true
});

document.addEventListener(
  "shopify:section:load",
  smRefreshScrollingElements
);

document.addEventListener("shopify:section:unload", () => {
  smScrollingElements = smScrollingElements.filter(
    (element) => element.isConnected
  );

  smQueueScrolling();
});

document.addEventListener(
  "shopify:section:reorder",
  smQueueScrolling
);

/* Same-page menu navigation */

class SmoothScrollMenu {
  constructor(selector) {
    this.menuItems = document.querySelectorAll(selector);
    this.attachEvents();
    this.hideMenuItemsWithoutSection();
  }

  attachEvents() {
    this.menuItems.forEach((item) => {
      const anchor = item.querySelector("a");
      const href = anchor?.getAttribute("href");

      if (!anchor || !href || href === "#") return;
      if (anchor.dataset.smSmoothScrollBound === "true") return;

      anchor.dataset.smSmoothScrollBound = "true";

      anchor.addEventListener("click", (event) => {
        this.handleMenuItemClick(event, anchor);
      });
    });
  }

  handleMenuItemClick(event, anchor) {
    if (
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      anchor.hasAttribute("download") ||
      (anchor.target && anchor.target !== "_self")
    ) {
      return;
    }

    let destination;

    try {
      destination = new URL(anchor.href, window.location.href);
    } catch {
      return;
    }

    if (
      destination.origin !== window.location.origin ||
      destination.pathname !== window.location.pathname ||
      destination.search !== window.location.search ||
      !destination.hash
    ) {
      return;
    }

    const target = this.getHashTarget(destination.hash);
    if (!target) return;

    event.preventDefault();
    this.scrollToSection(target);
  }

  getHashTarget(hash) {
    try {
      return document.getElementById(
        decodeURIComponent(hash.replace(/^#/, ""))
      );
    } catch {
      return null;
    }
  }

  scrollToSection(element) {
    this.smoothScrollTo(element);
  }

  smoothScrollTo(element) {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    window.scrollTo({
      behavior: reduceMotion ? "auto" : "smooth",
      top: element.getBoundingClientRect().top + window.scrollY
    });
  }

  hideMenuItemsWithoutSection() {
    this.menuItems.forEach((item) => {
      const anchor = item.querySelector("a");
      const href = anchor?.getAttribute("href");

      if (!href || href === "#") return;

      let destination;

      try {
        destination = new URL(href, window.location.href);
      } catch {
        return;
      }

      const samePage =
        destination.origin === window.location.origin &&
        destination.pathname === window.location.pathname &&
        destination.search === window.location.search;

      if (
        samePage &&
        destination.hash &&
        !this.getHashTarget(destination.hash)
      ) {
        item.style.display = "none";
      }
    });
  }
}

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    if (!this.mainDetailsToggle) return;

    this.addEventListener("keyup", this.onKeyUp.bind(this));

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
  }

  onKeyUp(event) {
    if (event.key !== "Escape") return;

    const details = event.target.closest("details[open]");
    if (!details) return;

    details.removeAttribute("open");
    details.querySelector("summary")?.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  close() {
    this.mainDetailsToggle?.removeAttribute("open");
  }
}

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");

    this.onSignInCompleted =
      this.handleStorefrontSignInCompleted.bind(this);
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.onSignInCompleted
    );
  }

  disconnectedCallback() {
    document.removeEventListener(
      "storefront:signincompleted",
      this.onSignInCompleted
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar && this.icon) {
      const avatar = event.detail.avatar.cloneNode(true);

      this.icon.replaceWith(avatar);
      this.icon = avatar;
    }
  }
}

if (!customElements.get("account-icon")) {
  customElements.define("account-icon", AccountIcon);
}

/* Rotating product messages */

class PositiveVibesComponent extends HTMLElement {
  connectedCallback() {
    this.productPositiveVibes();
  }

  disconnectedCallback() {
    clearInterval(this.rotationTimer);

    this.sizeObserver?.disconnect();

    if (this.resizeFrame !== undefined) {
      cancelAnimationFrame(this.resizeFrame);
    }
  }

  productPositiveVibes() {
    clearInterval(this.rotationTimer);
    this.sizeObserver?.disconnect();

    const parent = this.querySelector(".text-vibes");
    if (!parent) return;

    const originalChildren = Array.from(
      parent.querySelectorAll(".text-vibes--child")
    ).filter((child) => child.dataset.smVibesClone !== "true");

    if (!originalChildren.length) return;

    parent.querySelectorAll('[data-sm-vibes-clone="true"]').forEach(
      (clone) => clone.remove()
    );

    this.heightPositive();

    if ("ResizeObserver" in window) {
      this.sizeObserver = new ResizeObserver(() => {
        if (this.resizeFrame !== undefined) {
          cancelAnimationFrame(this.resizeFrame);
        }

        this.resizeFrame = requestAnimationFrame(() => {
          this.heightPositive();
        });
      });

      originalChildren.forEach((child) => {
        this.sizeObserver.observe(child.querySelector("p") || child);
      });
    }

    if (originalChildren.length <= 1) return;

    const clone = originalChildren[0].cloneNode(true);

    clone.dataset.smVibesClone = "true";
    clone.setAttribute("aria-hidden", "true");

    clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(
      (element) => element.setAttribute("tabindex", "-1")
    );

    parent.appendChild(clone);

    const children = parent.querySelectorAll(".text-vibes--child");
    let currentIndex = 0;

    this.rotationTimer = setInterval(() => {
      if (document.hidden || !this.isConnected) return;

      const height = children[currentIndex].offsetHeight;
      const offset = height * -currentIndex;

      parent.style.transform = `translateY(${offset}px)`;
      parent.style.transition =
        currentIndex === 0 ? "none" : "transform .5s ease";

      currentIndex = (currentIndex + 1) % children.length;
    }, 3000);
  }

  heightPositive() {
    const children = Array.from(
      this.querySelectorAll(".text-vibes--child")
    );

    if (!children.length) return;

    const heights = children.map((child) => {
      const paragraph = child.querySelector("p");
      return paragraph ? paragraph.offsetHeight : child.scrollHeight;
    });

    const maximum = Math.max(...heights);
    if (!maximum) return;

    const height = `${maximum}px`;

    if (this.style.minHeight !== height) {
      this.style.minHeight = height;
    }

    children.forEach((child) => {
      if (child.style.minHeight !== height) {
        child.style.minHeight = height;
      }
    });
  }
}

/* Transparent header */

let smTransparentEditorEventsBound = false;

function checkTransparentHeader() {
  allowTransparent();

  if (Shopify.designMode && !smTransparentEditorEventsBound) {
    smTransparentEditorEventsBound = true;

    document.addEventListener("shopify:section:load", allowTransparent);
    document.addEventListener("shopify:section:unload", allowTransparent);
    document.addEventListener("shopify:section:reorder", allowTransparent);
  }
}

function allowTransparent() {
  if (
    !document.querySelector(
      ".shopify-section:first-child [allow-transparent-header]"
    )
  ) {
    document.body?.removeAttribute("allow-transparency");
  }
}

/* Component initialization */

function smInitializeGlobalComponents() {
  new SmoothScrollMenu(".header__inline-menu .menu-lv-1");

  if (!customElements.get("details-disclosure")) {
    customElements.define("details-disclosure", DetailsDisclosure);
  }

  if (!customElements.get("positive-vibes")) {
    customElements.define("positive-vibes", PositiveVibesComponent);
  }

  smRefreshScrollingElements();
  checkTransparentHeader();
}

function smInitializeLoadedComponents() {
  if (!customElements.get("cart-update-quantity")) {
    customElements.define("cart-update-quantity", UpdateQuantity);
  }

  if (!customElements.get("quickshop-update-quantity")) {
    customElements.define(
      "quickshop-update-quantity",
      UpdateQuantityQuickShop
    );
  }

  if (!customElements.get("product-scroller")) {
    customElements.define("product-scroller", ProductScroller);
  }

  if (!customElements.get("fade-in-component")) {
    customElements.define("fade-in-component", FadeInComponent);
  }

  smRefreshScrollingElements();
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    smInitializeGlobalComponents,
    { once: true }
  );
} else {
  smInitializeGlobalComponents();
}

if (document.readyState === "complete") {
  smInitializeLoadedComponents();
} else {
  window.addEventListener("load", smInitializeLoadedComponents, {
    once: true
  });
}